import { initialState } from 'store/reducers/plCustomer';
import { PLCustomerData } from 'types/plCustomerData';

import { Store } from '../../types';

export const plCustomerSelector = (state: Store): PLCustomerData =>
	state.plCustomer ? state.plCustomer : initialState;
